// import external dependencies
import './util/SplitText';

import './lazy-load-background-images';
import './glide';
import PronunciationBanner from './pronunciation-banner';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import nutrition from './routes/nutrition';
import menu from './routes/menu';
import catering from './routes/catering';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    home,
    nutrition,
    menu,
    catering
});

// Load Events
jQuery(document).ready(() => {
    routes.loadEvents();
    new PronunciationBanner();
});

// Trigger lightbox
jQuery('#ilightbox').iLightBox();
